import { defineStore } from 'pinia';
import { useUiStore } from '@/stores/useUiStore';
import { useToaster } from '@/composables/useToaster';

const toaster = useToaster();

export const useImagesStore = defineStore('images', () => {
  function pipeFileAsBase64To ({
    file,
    handler,
  }: {
    file: File;
    handler: (
      file: File,
      base64: string,
      isVector: boolean,
    ) => Promise<void>;
  }) {
    return new Promise<void>((resolve, reject) => {
      if (!file.type.startsWith('image')) {
        toaster.error('Je kunt alleen een afbeelding uploaden.');
        reject(new Error('Unsupported file type'));
        return;
      }

      const isVector = file.type === 'image/svg+xml';
      const uiStore = useUiStore();
      uiStore.addLoadingElement(file);

      const reader = new FileReader();

      reader.addEventListener('error', () => {
        uiStore.removeLoadingElement(file);
        toaster.error('Het bestand kon niet worden gelezen.');
        reject(new Error('Error reading file'));
      });

      reader.addEventListener('load', () => {
        handler(
          file,
          reader.result as string,
          isVector,
        )
          .then(() => {
            resolve();
          })
          .catch((error: unknown) => {
            toaster.error('Het bestand kon niet worden ingeladen.');
            reject(error);
          })
          .finally(() => {
            uiStore.removeLoadingElement(file);
          });
      });

      reader.readAsDataURL(file);
    });
  }

  return {
    pipeFileAsBase64To,
  };
});
